<template>
          <v-card  style="margin-top: 2rem">
            <v-card-title class="subheading font-weight-bold">{{ item.archive ? item.archive.custom_name : "Brak archiwum" }}</v-card-title>
            <v-divider></v-divider>
            <v-container>
            <v-layout justify-center row align-content-center wrap>
              <v-flex lg3 sm6 xs12>
                <v-img v-if="item.archive && item.archive.thumb_img" :src="'data:image/png;base64,'+ (item.archive && item.archive.thumb_img ? item.archive.thumb_img : '')" aspect-ratio="1" class="cursorPointner"
                       contain max-height="256"
                       max-width="256"></v-img>
              </v-flex>
              <v-flex lg2 sm6 xs12>
                <v-text-field style="margin-top: 2rem" :value="getUser(item.created_by)" label="Autor:" prepend-icon="person" readonly></v-text-field>
                <v-text-field style="margin-top: 2rem" :value="item.created_at" label="Czas utworzenia:" prepend-icon="event" readonly></v-text-field>
              </v-flex>
              <v-flex lg2 sm12>
                <v-text-field  style="margin-top: 2rem" :value="item.schema.name" label="Dokument: " prepend-icon="check" readonly></v-text-field>
<!--                <v-select v-else prepend-icon="library_books" style="margin-top: 2rem" v-model="schemaAssigned[item.id]" :items="schemas" item-text="name" item-value="id" :label="`Schemat`"></v-select>-->
                <v-text-field style="margin-top: 2rem" :value="getStatus(item.status)" label="Status: " prepend-icon="check" readonly></v-text-field>
              </v-flex>
              <v-flex v-if="!viewOnly" lg2 sm12>
                <slot name="actions" v-bind:item="item">
                <v-btn style="margin-top: 2rem; float: right" color="green" @click="createForm(item.id)">Tworzenie</v-btn>
                </slot>
              </v-flex>
            </v-layout>
            </v-container>
          </v-card>
</template>

<script>
import Presentation from "@/components/form/Presentation";
import PDFViewer from "@/components/pdf/Viewer"
import Messenger from "@/plugins/Messenger";
export default {
  name: "Waiting",
  components:{
    Presentation,
    PDFViewer
  },
  props: ['item','schemas','viewOnly', ''],
  data:()=>({
    documents : [],
    fields :[],
    file:null,
    schemaAssigned :{},
    loading : true,
    rowsPerPageItems: [4, 8, 12],
    pagination: {
      rowsPerPage: 4
    },
  }),
  created() {

  },
  methods:{
    createForm(documentId){
      this.$router.push(`document/${documentId}/create-form`)
    },
    assign(documentId){
      let schemaId = this.schemaAssigned[documentId]
      if(!(schemaId >0)){
        Messenger.emitError("Najpierw wybierz schemat")
        return
      }
      let data = {'schema_id' :schemaId, 'document_id' : documentId }
      this.$http.post('document/ocr/assign', data).then(() => {
        this.documents = this.documents.filter(docs => docs.id != documentId)
      }).catch(()=>Messenger.emitError("Błąd"))
    },
    base64toPDF(data) {
      var bufferArray = this.base64ToArrayBuffer(data);
      var blobStore = new Blob([bufferArray], { type: "application/pdf" });
      return blobStore
    },
    base64ToArrayBuffer(data) {
      var bString = window.atob(data);
      var bLength = bString.length;
      var bytes = new Uint8Array(bLength);
      for (var i = 0; i < bLength; i++) {
        var ascii = bString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    getUser(id){
      let user = this.$store.getters.user(id)
      if(!user)
        return ""
      return user.name + " " + user.surname
    },
    getStatus(state){
      switch (parseInt(state)){
      case 1:
        return "Procesuje"
      case 2:
        return "Oczekuje"
      case 400:
        return "Błąd"
      default:
        return "Inny"
      }
    }
  },
}
</script>

<style scoped>

</style>